import VSelect from 'vue-select';
import {createNamespacedHelpers} from "vuex";
import {optionsToValueMap} from "@modules/AudienceManager/Util";

const {mapGetters, mapMutations} = createNamespacedHelpers('audienceManager/builder');

export default {
    name: "SelectQuestion",
    components: {
        VSelect
    },
    methods: {
        //We only care about the actual value
        reduceSelectedOption: option => option.value,
        ...mapMutations({
            setQuestionValue(commit, value) {
                commit('setQuestionValue', {
                    questionId: this.questionId,
                    value: value || undefined
                });
            }
        })
    },
    computed: {
        isMulti(){
            //According to the screenshots provided in the functional design
            //our 'select' should be a multi select
            return true;
        },
        value(){
            const selectedValue = this.questionValue(this.questionId);
            const optionValueMap = optionsToValueMap(this.options);
            
            if(this.isMulti){
                return (selectedValue || []).map(v => optionValueMap.get(v));
            }
            
            //We assume the selectedValue is but a key
            return optionValueMap.get(selectedValue);
        },
        /**
         * Available options for the current question
         * @returns {Array<{label: string, value: string}>} Options presented as array
         */
        options(){
            return this.questionOptions(this.questionId);
        },
        ...mapGetters(['questionOptions', 'questionValue']),
        ...mapGetters({
            'canEdit': 'canEditAudienceQuestionAnswers'
        })
    },
    props: {
        questionId: {
            type: String,
            //required: true,
            default: 'test-single-select'
        }
    }
}